export const TOOLTIP_DEBOUNCE = 1000 / 144;
export const AXIS_LEFT_OFFSET = 45; // wide enough for 4 figure numbers
export const AXIS_TOP_OFFSET = 15; // tall enough for the highest y tick
export const AXIS_BOTTOM_OFFSET = 25; // tall enough for the x axis labels
